export enum FeeSheetTypeEnum {
  Cap = 0,
  Target = 1
}

export enum FeeSheetTypeNameEnum {
  Cap = 'Cap',
  Target = 'Target'
}
